/* eslint-disable */
import React from 'react';
import { parseMoney } from '../utils';

const monthsObj = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
}

let revenue621Accounts = [
    {
        copy: 'Gross Charges',
        key: 'total_revenue_gross_charges',
    },
    {
        copy: 'Adjustments',
        key: 'total_revenue_adjustments',
    }
]

const revenueDisplay = (pdf, revenueThisYear, revenueLastYear, monthType, year) => {
    const firstTitleClass = pdf ? 'pdf-analysis-value-first-title' : 'analysis-value-first-title'
    const secondTitleClass = pdf ? 'pdf-analysis-value-second-title' : 'analysis-value-second-title'
    const dollarValClass = pdf ? 'pdf-analysis-value' : 'analysis-value'
    const diffValClass = pdf ? 'pdf-difference-text' : 'difference-text'
    let title = ''
    let paranthesisTitle = ''
    let endYear = String(year).slice(-2)
    let value = ''
    let displayDifference = false;
    let diffVal = ''
    let diffText1, diffText2 = ''
    let currentYearData = revenueThisYear
    let prevYearData = revenueLastYear

    if (currentYearData) {
        if (monthType === 'currentMonth') {
            displayDifference = true
            title = 'CURR. MONTH REVENUE'
            let totalRevenue = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
            if (currentMonth > 0) {
                paranthesisTitle = ` (${monthsObj[currentMonth]} ${endYear})`
                value = parseMoney(totalRevenue[currentMonth - 1])
                // ((Current Month Revenue - Last Month Revenue) / Last Month Revenue) * 100
                diffVal = ((totalRevenue[currentMonth - 1] - totalRevenue[currentMonth - 2]) / totalRevenue[currentMonth - 2]) * 100
                diffText1 = diffVal > 0 ? <span className='good-arrow'>&#9650; {diffVal.toFixed(2) + '%'}</span> : <span className='bad-arrow'>&#9660; {diffVal.toFixed(2) + '%'}</span>
                diffText2 = ' from last month'
            } else {
                paranthesisTitle = `(Dec ${endYear})`
            }
        }
    
        if (monthType === 'lastMonth') {
            title = 'LAST MONTH REVENUE'
            let totalRevenue = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
            if (currentMonth - 1 > 0) {
                paranthesisTitle = ` (${monthsObj[currentMonth - 1]} ${endYear})`
                value = parseMoney(totalRevenue[currentMonth - 2])
            }
        }
    
        if (monthType === 'ytd') {
            displayDifference = prevYearData ? true : false
            title = 'THIS YEAR TOTAL REVENUE'
            paranthesisTitle = `(${year} YTD)`
            let totalRevenue = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
            let ytd = currentYearData ? Object.values(currentYearData).reduce((a, b) => a + b, 0) : 0
            let previousYTD = prevYearData ? Object.values(prevYearData).slice(0, currentMonth).reduce((a, b) => a + b, 0) : 0
    
            diffVal = ((ytd - previousYTD) / previousYTD) * 100
            diffText1 = diffVal > 0 ? <span className='good-arrow'>&#9650; {diffVal.toFixed(2) + '%'}</span> : <span className='bad-arrow'>&#9660; {diffVal.toFixed(2) + '%'}</span>
            diffText2 = ' from last year (YTD)'
            value = parseMoney(ytd)
        }
    }


    return (
        <>
            <div className='analysis-value-title'><span className={firstTitleClass}>{title}</span><span className={secondTitleClass}>{paranthesisTitle}</span></div>
            <hr className='custom-report-line' />
            {currentYearData ? <span className={dollarValClass}>{value}</span> : <span>Need Monthly Data For This Year</span>}
            {displayDifference ? <div className={diffValClass}>{diffText1}<span>{diffText2}</span></div> : null}
        </>
    )
}

const expensesDisplay = (pdf, opexThisYear, opexLastYear, monthType, year) => {
    const firstTitleClass = pdf ? 'pdf-analysis-value-first-title' : 'analysis-value-first-title'
    const secondTitleClass = pdf ? 'pdf-analysis-value-second-title' : 'analysis-value-second-title'
    const dollarValClass = pdf ? 'pdf-analysis-value' : 'analysis-value'
    const diffValClass = pdf ? 'pdf-difference-text' : 'difference-text'
    let title = ''
    let paranthesisTitle = ''
    let endYear = String(year).slice(-2)
    let value = ''
    let displayDifference = false;
    let diffVal = ''
    let diffText1, diffText2 = ''
    let currentYearData = opexThisYear
    let prevYearData = opexLastYear

    if (currentYearData) {
        if (monthType === 'currentMonth') {
            displayDifference = true
            title = 'CURR. MONTH EXPENSES'
            let totalOpEx = currentYearData ? Object.values(currentYearData) : []
    
            let currentMonth = totalOpEx && totalOpEx.indexOf(null) !== -1 ? totalOpEx.indexOf(null) : 12;
            if (currentMonth > 0) {
                paranthesisTitle = ` (${monthsObj[currentMonth]} ${endYear})`
                value = parseMoney(totalOpEx[currentMonth - 1])
                // ((Current Month Revenue - Last Month Revenue) / Last Month Revenue) * 100
                diffVal = ((totalOpEx[currentMonth - 1] - totalOpEx[currentMonth - 2]) / totalOpEx[currentMonth - 2]) * 100
                diffText1 = diffVal > 0 ? <span className='bad-arrow'>&#9650; {diffVal.toFixed(2) + '%'}</span> : <span className='good-arrow'>&#9660; {diffVal.toFixed(2) + '%'}</span>
                diffText2 = ' from last month'
            } else {
                paranthesisTitle = `(Dec ${endYear})`
            }
        }
    
        if (monthType === 'lastMonth') {
            title = 'LAST MONTH EXPENSES'
            let totalOpEx = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalOpEx && totalOpEx.indexOf(null) !== -1 ? totalOpEx.indexOf(null) : 12;
            if (currentMonth - 1 > 0) {
                paranthesisTitle = ` (${monthsObj[currentMonth - 1]} ${endYear})`
                value = parseMoney(totalOpEx[currentMonth - 2])
            }
        }
    
        if (monthType === 'ytd') {
            displayDifference = true
            title = 'THIS YEAR TOTAL EXPENSES'
            paranthesisTitle = `(${year} YTD)`
            let totalOpEx = currentYearData ? Object.values(currentYearData) : []
            let currentMonth = totalOpEx && totalOpEx.indexOf(null) !== -1 ? totalOpEx.indexOf(null) : 12;
            let ytd = currentYearData ? Object.values(currentYearData).reduce((a, b) => a + b, 0) : 0
            let previousYTD = prevYearData ? Object.values(prevYearData).slice(0, currentMonth).reduce((a, b) => a + b, 0) : 0
    
            diffVal = ((ytd - previousYTD) / previousYTD) * 100
            diffText1 = diffVal > 0 ? <span className='bad-arrow'>&#9650; {diffVal.toFixed(2) + '%'}</span> : <span className='good-arrow'>&#9660; {diffVal.toFixed(2) + '%'}</span>
            diffText2 = ' from last year (YTD)'
            value = parseMoney(ytd)
        }
    }

    return (
        <>
            <div className='analysis-value-title'><span className={firstTitleClass}>{title}</span><span className={secondTitleClass}>{paranthesisTitle}</span></div>
            <hr className='custom-report-line' />
            {currentYearData ? <span className={dollarValClass}>{value}</span> : <span>Need Monthly Data For This Year</span>}
            {displayDifference ? <div className={diffValClass}>{diffText1}<span>{diffText2}</span></div> : null}
        </>
    )
}

const revenueTop10Chart = (pdf, revenueThisYear, monthly_calcs, year, naicsCode, title) => {
    const classTitle = pdf ? 'pdf-analysis-chart-title' : 'analysis-chart-title'
    const classChart = pdf ? 'pdf-top10-chart-container' : 'top10-chart-container'
    const classChartItem = pdf ? 'pdf-top10-chart-item' : 'top10-chart-item'
    const classDetailsDiv = pdf ? 'pdf-top10-details' : 'top10-details'
    const classDetailBack = pdf ? 'pdf-top10-green-background' : 'top10-green-background'

    let totalRevenue = revenueThisYear
    let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
    let revenue621Keys = naicsCode.startsWith('621') ? revenue621Accounts : null;
    let finalRev = []
    if (revenue621Keys) {
        revenue621Keys = revenue621Keys.map((r, i) => {
            r.value = monthly_calcs?.you?.[r.key]?.[year]?.[currentMonth]
            return r
        })
    }
    let sortedRev = revenue621Keys ? revenue621Keys.sort((a, b) => b.value - a.value) : []
    finalRev = sortedRev.map(t => {
        let topRev = sortedRev[0]
        t.percent = (t.value / topRev.value) * 100
        return t
    })

    return (
        <div key='revenue-top-10-chart' className={classChart}>
            <div className={classTitle}>{title}</div>
            {
                !revenue621Keys && (<div className={classChartItem}>
                    <div className={classDetailsDiv}><span>Total Revenue</span> <span>{parseMoney(totalRevenue[currentMonth - 1])}</span></div>
                    <div className={classDetailBack}></div>
                </div>)
            }
            {
                revenue621Keys && (finalRev.map((r, i) => {
                    let barStyle = { 'width': r.percent + '%' }
                    return (
                        <div className={classChartItem} key={`rev-item-${i}`}>
                            <div className={classDetailsDiv}><span>{r.copy}</span> <span>{parseMoney(r.value)}</span></div>
                            <div className={classDetailBack} style={barStyle}></div>
                        </div>
                    )
                }))
            }
        </div>
    )
}

const getChildrenKeys = (opexTree, monthly_calcs, currentMonth, year) => {
    if (opexTree && opexTree.children) {
        let childKeys = Object.keys(opexTree.children)
        let childObj = []

        if (childKeys.length > 0) {
            childKeys.forEach(child => {
                opexTree.children[child].key = child
                opexTree.children[child].value = monthly_calcs?.you?.[child] ? monthly_calcs.you?.[child]?.[year]?.[currentMonth] : 0
                childObj.push(opexTree.children[child])

                if (opexTree.children[child].children) {
                    let moreChildren = getChildrenKeys(opexTree.children[child], monthly_calcs, currentMonth, year)
                    childObj = [...childObj, ...moreChildren]
                }
            })
        }
        return childObj
    }
}

const expensesTop10Chart = (pdf, revenueThisYear, tree, monthly_calcs, year, title) => {
    const classTitle = pdf ? 'pdf-analysis-chart-title' : 'analysis-chart-title'
    const classChart = pdf ? 'pdf-top10-chart-container' : 'top10-chart-container'
    const classChartItem = pdf ? 'pdf-top10-chart-item' : 'top10-chart-item'
    const classDetailsDiv = pdf ? 'pdf-top10-details' : 'top10-details'
    const classDetailBack = pdf ? 'pdf-top10-expenses-background' : 'top10-expenses-background'
    let totalRevenue = revenueThisYear
    let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
    let opExChildren = tree ? tree?.pnl?.children?.total_operating_expenses : {}
    let allOpexKeys = getChildrenKeys(opExChildren, monthly_calcs, currentMonth, year)
    let filteredExpenses = allOpexKeys ? allOpexKeys.filter(a => !['total_people_costs', 'total_customer_costs', 'total_customers_costs', 'total_operations', 'total_compensation'].includes(a.key)) : []
    let sortedExpenses = [...filteredExpenses].sort((a, b) => b.value - a.value)
    let top10Expenses = sortedExpenses.slice(0, 10)
    let topExpense = top10Expenses[0]
    let top10WithPercents = top10Expenses.map(t => {
        t.percent = (t.value / topExpense.value) * 100
        return t
    })

    return (
        <div key='expenses-top-10-chart' className={classChart}>
            <div className={classTitle}>{title}</div>
            {top10WithPercents.map((t, i) => {
                let barStyle = { 'width': t.percent + '%' }
                return (
                    <div className={classChartItem} key={`ex-item-${i}`}>
                        <div className={classDetailsDiv}><span>{t.copy}</span> <span>{parseMoney(t.value)}</span></div>
                        <div className={classDetailBack} style={barStyle}></div>
                    </div>
                )
            })}
        </div>
    )
}

const axisFormat = (format, num) => {
    switch (format) {
        case 'percent':
            return `${Highcharts.numberFormat((num * 100), 0, '', ',')}%`;
        case 'decimal':
            return Highcharts.numberFormat(num, 0);
        case 'ratio':
            return `${Highcharts.numberFormat(num, 0, '.', ',')}:1`;
        case 'money':
            if (Math.abs(num) >= 1000000) {
                return num >= 0 ? `$${Highcharts.numberFormat(num / 1000000, 1)}M` : `-$${Highcharts.numberFormat(Math.abs(num / 1000000), 1)}M`;
            } else {
                return num >= 0 ? `$${Highcharts.numberFormat(num / 1000, 0)}K` : `-$${Highcharts.numberFormat(Math.abs(num / 1000), 0)}K`;
            }
        case 'wholeNumber':
            return Math.round(num)
    }
}

const valsCummulativeByMonth = (monthlyRevenue = []) => {
    let revenueValues = []
    let revenueTotal = 0
    for (let i = 0; i < monthlyRevenue.length; i++) {
        revenueTotal += monthlyRevenue[i]
        revenueValues.push(revenueTotal)
    }
    return revenueValues
}

const revAndOpexAreaChartOptions = (pdf, metric, values, year) => {
    const pdfTitleStyle = pdf ? { color: '#525252', fontSize: '0.8em' } : { color: '#525252', fontSize: '1.2em' }
    const pdfLabelStyle = pdf ? { fontSize: '0.6em' } : { fontSize: '0.8em' }
    const pdfLegendStyle = pdf ? { fontSize: '0.6em' } : { fontSize: '0.8em' }
    let endYear = String(year).slice(-2)
    let xAxisCats = Object.values(monthsObj).map(m => `${m} ${endYear}`)
    let metricValues = values
    let cummulativeVals = valsCummulativeByMonth(metricValues)
    let finalTitle = metric === 'total_revenue' ? 'Total Revenue This Year (Cummulative)' : 'Total Expenses This Year (Cummulative)'
    let lengendLabel = metric === 'total_revenue' ? 'Total Revenue' : 'Total Expenses'
    let lineColor = metric === 'total_revenue' ? '#69B144' : '#e46b50'
    let areaColor = metric === 'total_revenue' ? '#d7e5ce' : '#fbddcc'

    return {
        chart: {
            type: 'area'
        },
        accessibility: {
            description: finalTitle
        },
        title: {
            align: 'left',
            text: finalTitle,
            style: pdfTitleStyle
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            x: -10,
            y: 0,
            floating: true,
            symbolRadius: 0,
            itemStyle: pdfLegendStyle,
        },
        credits: {
            enabled: false
        },
        navigation: {
            buttonOptions: {
                enabled: false
            }
        },
        xAxis: {
            categories: xAxisCats,
            gridLineDashStyle: 'ShortDot',
            gridLineWidth: 1,
            startOnTick: true,
            tickPosition: 'inside',
            tickInterval: 2,
            tickLength: 5,
            tickWidth: 1,
            labels: {
                style: pdfLabelStyle
            }
        },
        yAxis: {
            title: {
                text: null
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return axisFormat('money', this.value)
                    } else {
                        return 0
                    }
                },
                style: pdfLabelStyle
            },
        },
        tooltip: {
            enabled: pdf ? false : true,
            style: {
                stroke: "none",
            },
            useHTML: true,
            formatter: function () {
                return this.y >= 0 ? ` $${Highcharts.numberFormat(this.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(this.y), 0, '.', ',')}`;
            }
        },
        plotOptions: {
            area: {
                fillColor: areaColor,
                marker: {
                    enabled: true,
                    fillColor: '#FFFFFF',
                    lineWidth: 1,
                    radius: 2,
                    lineColor: null,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                }
            }
        },
        series: [{
            color: lineColor,
            name: lengendLabel,
            data: cummulativeVals
        }]
    };
}

const revAndOpexLineChartOptions = (pdf, metric, thisYear, lastYear, peersValues, forecastValues, forecastName = 'Forecast', year) => {
    const pdfTitleStyle = pdf ? { color: '#525252', fontSize: '0.8em' } : { color: '#525252', fontSize: '1.2em' }
    const pdfLabelStyle = pdf ? { fontSize: '0.6em' } : { fontSize: '0.8em' }
    const pdfLegendStyle = pdf ? { fontSize: '0.6em' } : { fontSize: '0.8em' }
    const pdfPlotStyle = pdf ? { fontSize: '0.6em' } : { fontSize: '0.8em' }
    let endYear = String(year).slice(-2)
    let xAxisCats = Object.values(monthsObj).map(m => `${m} ${endYear}`)
    let firstSeries = thisYear
    let secondSeries = lastYear
    let peersSeries = peersValues
    let forecastSeries = forecastValues
    let firstSeriesName = metric === 'total_revenue' ? 'Revenue' : 'Expenses'
    let lineColor = metric === 'total_revenue' ? '#69B144' : '#737373'
    let chartData = [
        {
            color: '#999999',
            name: 'Last Year',
            data: secondSeries,
            type: 'line',
            dashStyle: 'LongDash',
            legendSymbol: 'rectangle',
            legendIndex: 1
        },
        {
            color: lineColor,
            name: firstSeriesName,
            data: firstSeries,
            type: 'line',
            legendSymbol: 'rectangle',
            legendIndex: 0
        },
    ]

    if (peersSeries.length > 0) {
        chartData.unshift(
            {
                color: '#d3d3d3',
                name: 'Peers',
                data: peersSeries,
                type: 'line',
                legendSymbol: 'rectangle',
                legendIndex: 2
            
            }
        )
    }

    if (forecastSeries.length > 0) {
        chartData.unshift(
            {
                color: '#f17b5b',
                name: forecastName,
                data: forecastSeries,
                type: 'line',
                legendSymbol: 'rectangle',
                legendIndex: 3
            }
        )
    }

    let tooltipOrder = [firstSeriesName, 'Last Year', 'Peers', forecastName]

    return {
        accessibility: {
            description: 'This year expenses vs last year expenses vs peers expenses vs forecast expenses'
        },
        title: {
            align: 'left',
            text: `${firstSeriesName} YOY vs Peers vs Forecast`,
            style: pdfTitleStyle
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            x: -10,
            y: 8,
            floating: true,
            symbolRadius: 0,
            itemStyle: pdfLegendStyle,
        },
        credits: {
            enabled: false
        },
        navigation: {
            buttonOptions: {
                enabled: false
            }
        },
        xAxis: {
            categories: xAxisCats,
            gridLineDashStyle: 'ShortDot',
            gridLineWidth: 1,
            startOnTick: true,
            tickPosition: 'inside',
            tickInterval: 2,
            tickLength: 5,
            tickWidth: 1,
            labels: {
                style: pdfLabelStyle
            }
        },
        yAxis: {
            title: {
                text: null
            },
            gridLineWidth: 1,
            labels: {
                formatter: function () {
                    if (this.value) {
                        return axisFormat('money', this.value)
                    } else {
                        return 0
                    }
                },
                style: pdfLabelStyle
            },
        },
        tooltip: {
            enabled: pdf ? false : true,
            shared: true,
            style: {
                stroke: "none",
            },
            useHTML: true,
            formatter: function () {
                if (!this.points || !this.x) return false;
                const points = this.points.slice().sort((a, b) => {
                        return tooltipOrder.indexOf(a.series.name) - tooltipOrder.indexOf(b.series.name);
                    });

                let s = `<b>${this.x}</b><br/>`;
                points.forEach(point => {
                    let pointVal = point.y >= 0 ? ` $${Highcharts.numberFormat(point.y, 0, '.', ',')}` : ` -$${Highcharts.numberFormat(Math.abs(point.y), 0, '.', ',')}`;
                    s += `<span style="color:${point.series.color}">\u25CF</span> ${point.series.name}: <b>${pointVal}</b><br/>`;
                });
                return s;
            }
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    fillColor: '#FFFFFF',
                    lineWidth: 1,
                    radius: 2,
                    lineColor: null,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                }
            }
        },
        series: chartData
    };
}

export { revenueDisplay, expensesDisplay, revenueTop10Chart, expensesTop10Chart, revAndOpexAreaChartOptions, revAndOpexLineChartOptions }